<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-form v-model="valid">
                <v-btn
                        class="mx-0 btn-cancel"
                        small
                        :disabled="loading"
                        @click="$emit('cancel')"
                        outline
                        fab
                >
                    <v-icon>arrow_back</v-icon>
                </v-btn>

                <h1 v-if="$vuetify.breakpoint.xs" class="display-1">Starter</h1>
                <h1 v-else class="display-1">{{ starter.id ? $t('edit_starter') : $t('create_starter') }}</h1>

                <v-btn
                        class="btn-save mx-0"
                        color="primary"
                        @click="submit"
                        :disabled="!valid || loading || this.selectedDancers.length === 0"
                        round
                        :large="!$vuetify.breakpoint.xs"
                >{{ $t('save') }}</v-btn>

                <v-text-field
                        :label="$t('name_of_starter')"
                        v-model.trim="starter.name"
                        :rules="rules.name"
                        :counter="255"
                        :loading="loading"
                        :readonly="selectedDancers.length === 1"
                        @keyup.enter="submit"
                        outline
                        required
                ></v-text-field>

                <dancer-list selectable
                             show-broken
                             :selected.sync="selectedDancers"
                             :loading="!dancers.loaded || loading"
                ></dancer-list>
            </v-form>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import DancerListComponent from '../../components/user/DancerList';

    export default {
        components: {
            'dancer-list': DancerListComponent
        },
        props: {
            id: {
                type: [Number, String],
                default: null
            }
        },
        data () {
            return {
                selectedDancers: [],
                savedName: '',
                starter: {
                    id: null,
                    name: '',
                    dancers: []
                },
                loading: false,
                valid: false,
                rules: {
                    name: [
                        (v) => !!v || this.$t('rules.missing_name'),
                        (v) => v.length <= 255 || this.$t('rules.too_long', ['Name']),
                    ],
                    dancers: [
                        (v) => this.selectedDancers.length > 0 || this.$t('rules.missing_dancers')
                    ]
                }
            }
        },
        computed: mapState(['dancers']),
        watch: {
            selectedDancers(val, oldVal) {
                this.updateName(val, oldVal);
            }
        },
        mounted() {
            if (this.id) {
                this.loadStarter(this.id);
            }
        },
        methods: {
            onScroll (e) {
                console.log(e.target.scrollTop);
                console.log(e.target.scrollX);
                console.log(e.target.scrollY);
            },
            loadStarter(id) {
                this.loading = true;

                this.starter.id = parseInt(id);

                axios.get(`/api/v1/starter_templates/${id}`).then(response => {

                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'Starter konnte nicht geladen werden'
                        });
                        return;
                    }

                    this.starter.name = this.savedName = response.data.data.name;

                    response.data.data.dancers.forEach(dancer => {
                        let d = this.dancers.items.find(d => {
                            return d.id === dancer.id
                        });
                        this.selectedDancers.push(d);
                    });

                    this.loading = false;
                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            updateName(dancers, dancersBefore) {
                if ((dancers.length === 1 || dancers.length === 2) && (dancersBefore.length < 1 || dancersBefore.length > 2)) {
                    this.savedName = this.starter.name;
                }

                if (dancers.length === 1) {
                    this.starter.name = dancers[0].full_name;
                } else if (dancers.length === 2) {
                    if (this.savedName) {
                        this.starter.name = this.savedName;
                    } else {
                        this.starter.name = dancers[0].first_name + ' & ' + dancers[1].first_name;
                    }
                } else if (dancersBefore.length === 1 || dancersBefore.length === 2) {
                    this.starter.name = this.savedName;
                }
            },
            submit() {
                if (!this.valid || this.loading) {
                    console.log('not valid');
                    return;
                }

                this.loading = true;

                //copy dancers to data object
                this.starter.dancers = [];
                this.selectedDancers.forEach(dancer => {
                    this.starter.dancers.push(dancer.id);
                });

                axios.post('/api/v1/starter_templates', this.starter).then(response => {

                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: this.$t(response.data.message)
                        });
                        this.loading = false;

                        return;
                    }

                    if (this.starter.id) {
                        this.$store.commit('updateStarterTemplate', response.data.data);
                    } else {
                        this.$store.commit('addStarterTemplate', response.data.data);
                    }

                    this.loading = false;

                    this.$emit('submit');

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Starter erfolgreich gespeichert'
                    });

                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>
    form {
        width: 100%;
    }

    .btn-save {
        float: right;
        margin-top: 2px;
    }

    .btn-cancel {
        margin-top: -10px;
    }

    h1 {
        display: inline-block;
        margin-bottom: 18px;
        margin-left: 10px;
    }
</style>
